import $ from 'jquery';

// ie11/10 bug fix
if (!window.navigator.msPointerEnabled) {
  try {
    document.domain = 'murdoch.edu.au';
  } catch (e) {
    console.warn(e);
  }
}
// set jquery to global
global.$ = global.jQuery = $;
window.jQuery = $;
// global.jquery2 = jquery2;

//import "bootstrap/js/dist/alert";
import "bootstrap/js/dist/carousel";
import "bootstrap/js/dist/collapse";
import "bootstrap/js/dist/dropdown";
//import "bootstrap/js/dist/modal";
//import 'bootstrap/js/dist/tab';
//import 'bootstrap/js/dist/tooltip';
//import "bootstrap/js/dist/util";